import Sveip from '@nrk/dh-basis-sveip'
import styles from './bildesveip.module.css'

export default class Bildesveip extends Sveip {
  connectedCallback() {
    super.connectedCallback()
    setTimeout(() => this.#updateActiveVideoloop(0), 100)
    this.#createIntersectionObserver()
    this.addEventListener('click', this)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.#disconnectIntersectionObserver()
    this.removeEventListener('click', this)
  }

  handleEvent(event) {
    super.handleEvent?.(event)
    if (event.type === 'click' && event.target.classList.contains(styles.indicator)) {
      const indicator = event.target
      const parent = indicator.parentElement
      const index = Array.from(parent.children).indexOf(indicator)
      this.scrollToIndex(index, true)
    }
  }

  snapIdxChangedCallback(nextIdx) {
    super.snapIdxChangedCallback?.(nextIdx)
    if (typeof nextIdx !== 'number') {
      return
    }
    this.style.setProperty('--current-index', nextIdx + 1)
    this.#updateActiveVideoloop(nextIdx)
  }

  #updateActiveVideoloop(activeIdx) {
    for (const mediaElement of this.mediaElements) {
      const index = this.mediaElements.indexOf(mediaElement)
      if (mediaElement.localName === 'dh-bs-levende-stillbilde') {
        if (activeIdx === index) {
          mediaElement.setAttribute('data-state', 'ACTIVE')
        } else {
          mediaElement.removeAttribute('data-state')
        }
      }
    }
  }

  /**
   * Sets up an IntersectionObserver on the container element, to track when it is in the viewport.
   * TODO: This should be tracked on the individual media element once Safari supports scrollMargin
   */
  #createIntersectionObserver() {
    // Setting up an IntersectionObserver on the container element.
    this.containerObserver = new IntersectionObserver(([entry]) => {
      for (const mediaElement of this.mediaElements) {
        if (mediaElement.localName === 'dh-bs-levende-stillbilde') {
          if (entry.isIntersecting) {
            mediaElement.setAttribute('data-viewport-position', 'IN-VIEWPORT')
          } else {
            mediaElement.removeAttribute('data-viewport-position')
          }
        }
      }
    }, {})
    this.containerObserver.observe(this)
  }

  #disconnectIntersectionObserver() {
    if (this.containerObserver) {
      this.containerObserver.disconnect()
    }
  }

  get mediaElements() {
    return this.items.map((item) => item.querySelector(`img, .${styles.media}`))
  }
}
